export const ReduxCallTypesConst = {
  LIST: "list",
  ACTION: "action",
  DETAIL: "detail",
  OVERLAY: "overlay",
};
